import { formatDateWithTime } from "../../../shared/utility";
import TextWithLabel from "../../controls/TextWithLabel";

export default function PackagedProductTraceDetailFields({ singleItem }) {
  return (
    <div>
      <div className="grid grid-cols-4 gap-4">
        <div className="col-span-2">
          <TextWithLabel
            label={`Product Name (${singleItem.plu})`}
            text={singleItem.product_name}
          />
        </div>
        <div>
          <TextWithLabel
            label="Total Packaged"
            text={singleItem.total_individual_units}
          />
        </div>
        <div>
          <TextWithLabel label="In Stock" text={singleItem.in_stock} />
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4 mt-2">
        <div>
          <TextWithLabel
            label="Packaging Date"
            text={formatDateWithTime(singleItem.packaging_date)}
          />
        </div>
        <div>
          <TextWithLabel label="Brand" text={singleItem.brand_name} />
        </div>
        <div>
          <TextWithLabel label="Supervisor" text={singleItem.supervisor} />
        </div>
      </div>
      <div className="grid grid-cols-4 gap-4 mt-2">
        {singleItem.employee_1 ? (
          <div>
            <TextWithLabel label="Employee(s)" text={singleItem.employee_1} />
          </div>
        ) : null}
        <div>
          <TextWithLabel
            label="Best Before Date"
            text={singleItem.best_before_date}
          />
        </div>
        <div>
          <TextWithLabel label="Packing Size" text={singleItem.packing_size} />
        </div>
        <div>
          <TextWithLabel label="Shelf life" text={singleItem.shelf_life} />
        </div>
      </div>
      <div className="grid grid-cols-4 gap-4 mt-2">
        <div>
          <TextWithLabel
            label="Packaging Material 1"
            text={singleItem.packaging_material_1}
          />
        </div>
        <div>
          <TextWithLabel
            label="Packaging Material 2"
            text={singleItem.packaging_material_2}
          />
        </div>
        <div>
          <TextWithLabel
            label="Packaging Material 3"
            text={singleItem.packaging_material_3}
          />
        </div>
        <div>
          <TextWithLabel
            label="Room Temp C&deg;"
            text={singleItem.room_temperature}
          />
        </div>
        <div>
          <TextWithLabel
            label="Product Temp C&deg;"
            text={singleItem.product_temperature}
          />
        </div>
      </div>
      <div className="grid grid-cols-5 gap-4 mt-2">
        <div className="col-span-2">
          <TextWithLabel
            label="Skid Label"
            text={
              singleItem.skid_label_number
                ? singleItem.skid_label_number
                : "N/A"
            }
          />
        </div>
      </div>
    </div>
  );
}
